import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HisSharedModule } from '../his-shared.module';
import { RouterModule } from '@angular/router';
import { HisAccessDisabledPageComponent } from './access-disabled/his-access-disabled-page.component';
import { HisSubmenuComponent } from './submenu/his-submenu.component';

@NgModule( {
    imports: [
        CommonModule,
        RouterModule,
        HisSharedModule,
    ],
    declarations: [
        HisAccessDisabledPageComponent,
        HisSubmenuComponent
    ]
} )
export class HisPagesSharedModule { }
